export default __webpack_public_path__ + "static/media/astro.c2d7c474.jpg";